import { Head, router } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

import PtoRequestForm from "./_form"

interface Employee {
  id: number
  name: string
}

interface Props {
  pto_request: {
    request_type: number
    start_date: string | null
    end_date: string | null
    start_time: string
    start_period: string
    end_time: string
    end_period: string
    hours_requested: number
    full_day: boolean
    reason: string
  }
  request_types: { value: number; label: string }[]
  employees?: Employee[]
  can_manage?: boolean
  errors?: Record<string, string[]>
}

export default function New({
  pto_request,
  request_types,
  employees,
  can_manage,
  errors,
}: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "PTO Requests", href: "/pto_requests" },
    { title: "New Request", href: "/pto_requests/new" },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Request PTO" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Request PTO</h1>

        <div className="rounded-lg bg-white p-6 shadow">
          <PtoRequestForm
            ptoRequest={pto_request}
            requestTypes={request_types}
            employees={employees}
            canManage={can_manage}
            errors={errors}
            onCancel={() => router.get("/pto_requests")}
          />
        </div>
      </div>
    </AppLayout>
  )
}
